<template>
  <div v-loading="loading" class="brand-card">
    <div class="brand-card-header flex-column">
      <img src="/img/publishers/kijiji.png" height="50" alt="Kijiji" />
      <div class="mt-1 text-muted">past 30 days</div>
    </div>
    <div class="brand-card-body">
      <div>
        <div class="text-value">{{views}}</div>
        <div class="text-uppercase text-muted small">views</div>
      </div>
      <div>
        <div class="text-value">{{replies}}</div>
        <div class="text-uppercase text-muted small">replies</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardKijiji',

  data(){
    return {
      views   : 0,
      replies : 0,

      // state
      loading : false,
      error   : '',
    }
  },

  mounted(){
    this.load()
  },

  methods: {
    load(){
      this.loading = true
      this.$API.v2.Charts.AllKijijiListings()
      .then(({ views, replies }) => {
        this.views = views
        this.replies = replies
      })
      .catch((err) => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
    }
  }
};
</script>
